import React from 'react';
import { StyledLoader } from './Loader.styled';

export const Loader = () => {
  return <StyledLoader />;
};
